import React, { useEffect, useRef, useState } from "react";
import "./CriarClasseEstaleiroModal.css";

const sanitizeTextInput = (value, max = 80) =>
  String(value ?? "")
    .replace(/[\u0000-\u001F\u007F]/g, "")
    .replace(/[<>]/g, "")
    .toUpperCase()
    .slice(0, max);

const sanitizeTextSave = (value, max = 80) => sanitizeTextInput(value, max).trim();

export default function CriarClasseEstaleiroModal({ open, onClose, onSalvar }) {
  const [classe, setClasse] = useState("");
  const [subClasse, setSubClasse] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const classeRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    setClasse("");
    setSubClasse("");
    setBusy(false);
    setErr("");
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const t = setTimeout(() => classeRef.current?.focus(), 0);
    return () => {
      clearTimeout(t);
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open) return null;

  async function handleSalvar() {
    if (busy) return;
    setBusy(true);
    setErr("");
    try {
      const classeValue = sanitizeTextSave(classe);
      const subClasseValue = sanitizeTextSave(subClasse);
      if (!classeValue) throw new Error("Informe a classe.");
      await onSalvar?.({ classe: classeValue, subClasse: subClasseValue });
      onClose?.();
    } catch (e) {
      setErr(e?.response?.data?.error || e?.message || "Falha ao salvar.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="fbecr-overlay" onClick={onClose}>
      <div className="fbecr-card" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-label="Cadastrar classe">
        <div className="fbecr-head">
          <h3 className="fbecr-title">Cadastrar Classe</h3>
          <button className="fbecr-close" type="button" onClick={onClose} disabled={busy} aria-label="Fechar">
            x
          </button>
        </div>

        <div className="fbecr-body">
          <label className="fbecr-field">
            <span>Classe</span>
            <input
              ref={classeRef}
              type="text"
              value={classe}
              onChange={(e) => setClasse(sanitizeTextInput(e.target.value))}
              placeholder="Ex: RE G1"
              autoComplete="off"
            />
          </label>
          <label className="fbecr-field">
            <span>Sub-classe (opcional)</span>
            <input
              type="text"
              value={subClasse}
              onChange={(e) => setSubClasse(sanitizeTextInput(e.target.value))}
              placeholder="Ex: CL1"
              autoComplete="off"
            />
          </label>
          {err ? <div className="fbecr-error">{err}</div> : null}
        </div>

        <div className="fbecr-foot">
          <button className="fbecr-btn fbecr-btn-ghost" type="button" onClick={onClose} disabled={busy}>
            Cancelar
          </button>
          <button className="fbecr-btn fbecr-btn-primary" type="button" onClick={handleSalvar} disabled={busy}>
            {busy ? "Salvando..." : "Salvar"}
          </button>
        </div>
      </div>
    </div>
  );
}
